export default __webpack_public_path__ + "static/kamilt-53602e66bf5b87ff351a0b4ef8235fef.jpg";